import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Trash2, Plus, Pencil } from "lucide-react";

export default function AdminArticles() {
  const [articles, setArticles] = useState(null);

  const load = () => api.get("/admin/articles").then((res) => setArticles(res.data.items));
  useEffect(() => { load(); }, []);

  const handleDelete = async (slug) => {
    if (!window.confirm("Delete this article?")) return;
    await api.delete(`/admin/articles/${slug}`);
    toast.success("Article deleted");
    load();
  };

  return (
    <div data-testid="admin-articles-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-serif-heading font-bold text-navy">Articles</h1>
        <Button asChild data-testid="admin-new-article-button" className="bg-gold hover:bg-gold-600 text-navy font-bold">
          <Link to="/admin/articles/new"><Plus className="w-4 h-4 mr-1" /> New Article</Link>
        </Button>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Title</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Pillar</TableHead>
              <TableHead>Market</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>AI</TableHead>
              <TableHead></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {articles?.map((a) => (
              <TableRow key={a.id} data-testid={`admin-article-row-${a.slug}`}>
                <TableCell className="font-medium text-navy max-w-xs truncate">{a.title}</TableCell>
                <TableCell><Badge variant="secondary">{a.content_type}</Badge></TableCell>
                <TableCell className="text-slate-500 text-sm">{a.pillar}</TableCell>
                <TableCell><Badge variant="outline" data-testid={`admin-article-market-${a.slug}`}>{a.market || "US"}</Badge></TableCell>
                <TableCell><Badge variant={a.status === "published" ? "default" : "outline"}>{a.status}</Badge></TableCell>
                <TableCell>{a.ai_generated ? <Badge className="bg-blue-100 text-blue-700">{a.ai_provider}</Badge> : "—"}</TableCell>
                <TableCell className="flex gap-2">
                  <Link to={`/admin/articles/${a.slug}/edit`} data-testid={`admin-edit-article-${a.slug}`}><Pencil className="w-4 h-4 text-slate-500 hover:text-navy" /></Link>
                  <button onClick={() => handleDelete(a.slug)} data-testid={`admin-delete-article-${a.slug}`}><Trash2 className="w-4 h-4 text-slate-500 hover:text-red-600" /></button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
